import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_DATA from "./KAMPYLE_DATA";
import KAMPYLE_EVENT_DISPATCHER from "./KAMPYLE_EVENT_DISPATCHER";
import KAMPYLE_FUNC from "./KAMPYLE_FUNC";
import KAMPYLE_UTILS from "./KAMPYLE_UTILS";
import KAMPYLE_VIEW from "./KAMPYLE_VIEW";
import KAMPYLE_ANIMATION from './KAMPYLE_ANIMATION'
import MDIGITAL_ELEMENT_BUILDER from "./MDIGITAL_ELEMENT_BUILDER";

  var DEFAULTS = {
    ANIMATION_DIRECTION: 'centerRight',
  };

  function init() {
    var eventMapping = {
      neb_buttonClicked: [animateWithInit],
      neb_sdkShowForm: [animateWithInit],
      neb_loadForm: [handleAnimationIframe, initAnimationPosition, listenToResizeAnimation],
      neb_inviteAccepted: [animateWithInit],
      neb_skipInvitation: [animateWithInit],
      neb_formClosed: [animateOut, refreshFormIframe],
      neb_popupBlocked: [animateOut, refreshFormIframe],
      neb_captureInit: [animateOut],
      neb_captureImageClicked: [animateIn],
      MDigital_Capture_Cancelled: [animateIn],
      neb_formHide: [animateOut],
      neb_formLoadingHasFailed: [hideAnimationContainer],
      neb_skipShowingForm: [hideFormAnimationContainer],
      neb_resetFormState: [refreshFormIframe]
    };
    KAMPYLE_EVENT_DISPATCHER.subscribeMany(eventMapping);
  }

  function listenToResizeAnimation(eventName, data) {
    var formData = KAMPYLE_DATA.getFormData(data.formId);
    var isMobile = KAMPYLE_DATA.isMobile();
    var displayDirection = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'formDisplay.displayDirection');
    var shouldAdjustToZoom = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_ZOOM_WCAG_REFLOW) && KAMPYLE_UTILS.getNestedPropertyValue(formData, 'urlVersion');
    if (shouldAdjustToZoom && !isMobile && !!displayDirection && displayDirection.indexOf('center') > -1) {
      KAMPYLE_UTILS.setEventHandler(window, 'resize', debouncedOnResize(formData));
    }
  }

  function debouncedOnResize(formData) {
    var onResizeAnimationContainerBound = KAMPYLE_ANIMATION.resizeAnimationContainer.bind(null, formData);
    var debounced = KAMPYLE_UTILS.debounce(onResizeAnimationContainerBound, 100, true);
    KAMPYLE_ANIMATION.debouncedOnResize = debounced;
    return debounced;
  }

  function resizeAnimationContainer(formData) {
    var animationContainer = document.getElementById('KampyleAnimationContainer');
    KAMPYLE_UTILS.setElementStyle(animationContainer, {
      top: getMiddleHeight(formData.formHeight)
    });
  }

  function animateWithInit(eventName, data) {
    initAnimationPosition(eventName, data);

    setTimeout(function() {
      animateIn(eventName, data);
    }, 10);

  }

  function shouldIgnoreRenderAnimationForm(formData, animationContainer, formId){
    return !formData || !animationContainer || !isAnimationForm(formData) || KAMPYLE_FUNC.hasApplicationLoadingFailed(formId,false)
  }

  function animateIn(eventName, data) {

    data = data || {};
    var formData = KAMPYLE_DATA.getFormData(data.formId);
    var animationContainer = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.ANIMATION.CONTAINER_ID);
    if (shouldIgnoreRenderAnimationForm(formData, animationContainer, data.formId)) {
      return false;
    }

    //Show the form HTML element
    KAMPYLE_DATA.setMemoryData('isInvitationShouldBeIgnored', true);
    var formIframe = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.ANIMATION.IFRAME_ID + data.formId);
    var v1IframeStyle = {
      display: 'block',
      backgroundColor: formData.designSettings.formBackgroundColor || 'white'
    };
    var v2IframeStyle = {
      display: 'block',
      boxShadow: '-4px 0px 18px -1px rgba(0,0,0,0.37)',
      backgroundColor: formData.designSettings.formBackgroundColor || 'white'
    };
    if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_ZOOM_WCAG_REFLOW)) {
      v2IframeStyle.maxWidth = '100vw';
      v2IframeStyle.maxHeight = '100vh';
    }

    var displayDirection = getDisplayDirection(formData);
    switch (displayDirection) {
      case 'centerRight':
        KAMPYLE_UTILS.setElementStyle(animationContainer, {
          right: 0,
        });
        v2IframeStyle.borderRadius = '8px 0px 0px 8px';
        break;
      case 'centerLeft':
        KAMPYLE_UTILS.setElementStyle(animationContainer, {
          left: 0,
        });
        v2IframeStyle.borderRadius = '0px 8px 8px 0px';
        break;
      case 'bottomRight':
        KAMPYLE_UTILS.setElementStyle(animationContainer, {
          bottom: 0,
        });
        v2IframeStyle.borderRadius = '8px 0px 0px 0px';
        break;
      case 'bottomLeft':
        KAMPYLE_UTILS.setElementStyle(animationContainer, {
          bottom: 0,
        });
        v2IframeStyle.borderRadius = '0px 8px 0px 0px';
        break;
      case 'topRight':
        KAMPYLE_UTILS.setElementStyle(animationContainer, {
          top: 0,
        });
        v2IframeStyle.borderRadius = '0px 0px 0px 8px';
        break;
      case 'topLeft':
        KAMPYLE_UTILS.setElementStyle(animationContainer, {
          top: 0,
        });
        v2IframeStyle.borderRadius = '0px 0px 8px 0px';
        break;
      default:
        KAMPYLE_UTILS.showWarning('Invalid animation type - ' + displayDirection);
        return false;
    }

    if (formIframe) {
      if (KAMPYLE_DATA.isV2Form(data.formId)) {
        KAMPYLE_UTILS.setElementStyle(formIframe, v2IframeStyle);
      } else {
        KAMPYLE_UTILS.setElementStyle(formIframe, v1IframeStyle);
      }
    }
  }

  function hideAnimationContainer() {
    var animationContainer = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.ANIMATION.CONTAINER_ID);
    if (animationContainer) {
      KAMPYLE_UTILS.setElementStyle(animationContainer, {
        width: 0,
        height: 0,
      });
    }
  }

  function refreshFormIframe(eventName, data) {

    //when closing form reload iframe inorder to get clean form
    setTimeout(function () {
      var formData = KAMPYLE_DATA.getFormData(data.formId);

      var currIframe = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.ANIMATION.IFRAME_ID + data.formId);
      if (!!currIframe) {
        currIframe.remove();
        KAMPYLE_UTILS.removeEventHandler(window, 'resize', KAMPYLE_ANIMATION.debouncedOnResize);
        KAMPYLE_DATA.initOnsiteDefaultState(data.formId);
      }

      hideAnimationContainer();
    }, 1000);
  }

  function animateOut(eventName, data) {
    var formData = KAMPYLE_DATA.getFormData(data.formId);
    if (KAMPYLE_DATA.getDisplayType(formData) !== 'animation') {
      return false;
    }

    data = data || {};
    var animationContainer = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.ANIMATION.CONTAINER_ID);

    if (!formData || !animationContainer || !isAnimationForm(formData)) { return false; }

    setAnimationContainerInitialPosition(formData, animationContainer);
  }

  function getMiddleHeight(formHeight) {
    return String(Math.max(0, ((window.innerHeight - parseInt(formHeight, 10)) / 2))) + 'px';
  }

  function getDisplayDirection(formData) {
    formData = formData || {};
    return KAMPYLE_UTILS.getNestedPropertyValue(formData, 'formDisplay.displayDirection') || DEFAULTS.ANIMATION_DIRECTION;
  }

  function setAnimationContainerInitialPosition(formData, animationContainer) {
    var cornerMargin;
    switch (getDisplayDirection(formData)) {
      case 'centerRight':
        KAMPYLE_UTILS.setElementStyle(animationContainer, {
          top: getMiddleHeight(animationContainer.style.height),
          right: '-' + formData.formWidth + 'px',
          bottom: null,
          left: null,
          transition: 'right 1s ease-in-out',
        });
        break;
      case 'centerLeft':
        KAMPYLE_UTILS.setElementStyle(animationContainer, {
          top: getMiddleHeight(animationContainer.style.height),
          right: null,
          bottom: null,
          left: '-' + formData.formWidth + 'px',
          transition: 'left 1s ease-in-out',
        });
        break;
      case 'bottomRight':
        cornerMargin = KAMPYLE_VIEW.getCornerMargin(formData) + 'px';
        KAMPYLE_UTILS.setElementStyle(animationContainer, {
          top: null,
          right: cornerMargin,
          bottom: '-' + formData.formHeight + 'px',
          left: null,
          transition: 'bottom 1s ease-in-out',
        });
        break;
      case 'bottomLeft':
        cornerMargin = KAMPYLE_VIEW.getCornerMargin(formData) + 'px';
        KAMPYLE_UTILS.setElementStyle(animationContainer, {
          top: null,
          right: null,
          bottom: '-' + formData.formHeight + 'px',
          left: cornerMargin,
          transition: 'bottom 1s ease-in-out',
        });
        break;
        case 'topLeft':
          cornerMargin = KAMPYLE_VIEW.getCornerMargin(formData) + 'px';
          KAMPYLE_UTILS.setElementStyle(animationContainer, {
            top:  '-' + formData.formHeight + 'px',
            right: null,
            bottom: null,
            left: cornerMargin,
            transition: 'top 1s ease-in-out',
          });
          break;
          case 'topRight':
            cornerMargin = KAMPYLE_VIEW.getCornerMargin(formData) + 'px';
            KAMPYLE_UTILS.setElementStyle(animationContainer, {
              top:  '-' + formData.formHeight + 'px',
              right: cornerMargin,
              bottom: null,
              left: null,
              transition: 'top 1s ease-in-out',
            });
            break;
      default:
        KAMPYLE_UTILS.showWarning('Invalid animation type - ' + formData.formDisplayDirection);
        return false;
    }
  }

  function isAnimationForm(formData) {
    return KAMPYLE_DATA.getDisplayType(formData) === 'animation';
  }

  function hideFormAnimationContainer(eventName, data){
    //We would like to hide the animation container of a form which did not opened eventually
    var formData = KAMPYLE_DATA.getFormData(data.formId);
    if(isAnimationForm(formData)){
      var formIframe = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.ANIMATION.IFRAME_ID + data.formId);
      if(formIframe){
        KAMPYLE_UTILS.setElementStyle(formIframe, {
          display: 'none',
        });
      }
    }
  }

  function getOrCreateAnimationContainer(shouldAdjustToZoom){
    var container = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.ANIMATION.CONTAINER_ID);

    if(!container ) {
      //Create the animation container
      var formSpanPlacer = KAMPYLE_UTILS.getOrCreateWrapperContainer(KAMPYLE_CONSTANT.IFRAME_SETTINGS.ANIMATION.WRAPPER_ID);
      container = document.createElement('div');
      KAMPYLE_UTILS.addAttributesOnElement(container, {
        id: KAMPYLE_CONSTANT.IFRAME_SETTINGS.ANIMATION.CONTAINER_ID
      });
      container.style.zIndex = '2147483000';
      formSpanPlacer.appendChild(container);
      document.body.appendChild(formSpanPlacer);

      var containerStyle = {
        border: 0,
        position: 'fixed',
        display: 'block',
        zIndex: '2147483000',
      }
      if (shouldAdjustToZoom) {
        containerStyle.maxWidth = '100vw';
        containerStyle.maxHeight = '100vh';
      }
      KAMPYLE_UTILS.setElementStyle(container, containerStyle);
    }

    return container;
  }

  function handleAnimationIframe(eventName, data) {
    data = data || {};
    var formData = KAMPYLE_DATA.getFormData(data.formId);
    if (!formData || !KAMPYLE_ANIMATION.isAnimationForm(formData)) {
      return false;
    }
    var shouldAdjustToZoom = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_ZOOM_WCAG_REFLOW) && KAMPYLE_UTILS.getNestedPropertyValue(formData, 'urlVersion');
    var animationContainer = KAMPYLE_ANIMATION.getOrCreateAnimationContainer(shouldAdjustToZoom);
    var formIframe = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.ANIMATION.IFRAME_ID + data.formId);
    if (!formIframe) {
      var animationIframeStyle = {
        border: 0,
        height: formData.formHeight + 'px',
        width: formData.formWidth + 'px',
        display: 'none',
      }
      if (shouldAdjustToZoom) {
        animationIframeStyle.maxWidth = '100vw',
        animationIframeStyle.maxHeight = '100vh'
      }
     var isStyleImportant = false;
     KAMPYLE_VIEW.createFormIframe(data.formId,KAMPYLE_CONSTANT.IFRAME_SETTINGS.ANIMATION.IFRAME_ID,animationContainer,animationIframeStyle,isStyleImportant);
    }
    var spinnerContainer = animationContainer.querySelector("#" + KAMPYLE_CONSTANT.SPINNER_SETTINGS.CONTAINER_ID);
    if(!spinnerContainer) {
      spinnerContainer = MDIGITAL_ELEMENT_BUILDER.createSpinnerElement();
      animationContainer.appendChild(spinnerContainer);
      KAMPYLE_UTILS.setSpinnerStyle(spinnerContainer, KAMPYLE_CONSTANT.SPINNER_SETTINGS.SIZE.LARGE);
    }
  }

  function initAnimationPosition(eventName, data) {
    data = data || {};
    var formData = KAMPYLE_DATA.getFormData(data.formId);
    var isSkipInvitation = KAMPYLE_DATA.isSkipInvitation(data.formId);

    var animationContainer = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.ANIMATION.CONTAINER_ID);
    if (!animationContainer || !formData || !isAnimationForm(formData) || (isSkipInvitation && KAMPYLE_FUNC.isAnyOtherFormAlreadyShown(data.formId))) { return false; }

    if (!document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.ANIMATION.IFRAME_ID + data.formId)) {
      handleAnimationIframe(eventName, data);
    }

    KAMPYLE_UTILS.setElementStyle(animationContainer, {
      height: formData.formHeight + 'px',
      width: formData.formWidth + 'px',
    });

    setAnimationContainerInitialPosition(formData, animationContainer);
  }

  export default {
    //For Testing
    initAnimationPosition: initAnimationPosition,
    getDisplayDirection: getDisplayDirection,
    getOrCreateAnimationContainer: getOrCreateAnimationContainer,
    //Public API
    init: init,
    hideAnimationContainer:hideAnimationContainer,
    hideFormAnimationContainer:hideFormAnimationContainer,
    handleAnimationIframe:handleAnimationIframe,
    isAnimationForm:isAnimationForm,
    listenToResizeAnimation:listenToResizeAnimation,
    resizeAnimationContainer:resizeAnimationContainer,
    debouncedOnResize:debouncedOnResize,
  };
